import i18next from 'i18next';

export const generatePlanName = (currentPlanId, plan) =>
  currentPlanId === plan?.id
    ? plan?.name
    : i18next.t('sources:источники плана');

export const createBreadcrumbs = ({ route, plan, sourceName = '' }) => {
  const {
    path,
    params: { planId, calibrationId },
  } = route;

  const breadcrumbs = [
    {
      caption: i18next.t('планы'),
      link: '/plans',
    },
    {
      caption: generatePlanName(planId, plan),
      link: `/plans/${planId}/calibrations`,
    },
  ];

  const isCalibration = path.startsWith('/plans/:planId/calibrations/:calibrationId');
  const isValidation = path.startsWith('/plans/:planId/calibrations/:calibrationId/validation');

  if (isCalibration) {
    breadcrumbs.push({
      caption: i18next.t('sources:калибрация источника', { sourceName }),
      link: `/plans/${planId}/calibrations/${calibrationId}`,
    });
  }

  if (isValidation) {
    breadcrumbs.push({
      caption: i18next.t('sources:валидация'),
      link: `/plans/${planId}/calibrations/${calibrationId}/validation`,
    });
  }

  const lastIndex = breadcrumbs.length - 1;
  return breadcrumbs.map((item, index) =>
    index === lastIndex ? { ...item, link: undefined } : item
  );
};
